/** 只响应本站会话变化；返回页面时重新验证，换账号后重建页面数据。 */
export function installSessionRecheck({ auth, router, changeKey, windowObject = window, documentObject = document }) {
  let pending = null
  let disposed = false
  const check = () => {
    if (disposed || documentObject.visibilityState === 'hidden' || auth.loggingOut) return Promise.resolve()
    if (pending) return pending
    const previous = auth.user?.email || null
    const version = auth.authVersion
    const current = Promise.resolve().then(() => auth.fetchProfile())
      .then(() => {
        if (disposed || version !== auth.authVersion || auth.loggingOut) return
        const user = auth.user?.email || null
        const route = router.currentRoute.value
        if (previous !== user && previous) {
          windowObject.location.reload()
        } else if (!user && (route.meta.requiresAdmin || route.meta.requiresAuth)) {
          return router.replace({ path: '/login', query: { return_to: route.fullPath, logged_out: '1' } })
        }
      })
      .catch(() => { /* 暂时无法校验时保留身份，不冒充已退出。 */ })
      .finally(() => { if (pending === current) pending = null })
    pending = current
    return current
  }
  const onPageShow = event => event.persisted ? check() : Promise.resolve()
  const onStorage = event => event.key === changeKey ? check() : Promise.resolve()
  windowObject.addEventListener('pageshow', onPageShow)
  windowObject.addEventListener('storage', onStorage)
  documentObject.addEventListener('visibilitychange', check)
  return () => {
    disposed = true
    windowObject.removeEventListener('pageshow', onPageShow)
    windowObject.removeEventListener('storage', onStorage)
    documentObject.removeEventListener('visibilitychange', check)
  }
}
